import {ListSectionProps} from '../components/list-section';

export const getListSection =
  <T>(data: Omit<ListSectionProps<T>, 'type'>) =>
  (): ListSectionProps<T> =>
    ({
      ...data,
      type: 'list-section',
    } as ListSectionProps<T>);
